export default {
    LOAD_PRODUCT_MODELS (state, productmodels) {
        state.items = productmodels
    }
}